import Vue from 'vue'
import QrCodeVue from 'qrcode.vue'

Vue.component('QrCodeVue', QrCodeVue)
